const PaySecurelyIcon = (props) => (
  <svg
    width={10}
    height={9}
    viewBox="0 0 10 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.69842 3.02369H0.348883C0.15816 3.02369 0 2.86553 0 2.67481C0 2.48409 0.15816 2.32593 0.348883 2.32593H5.69842C5.88914 2.32593 6.0473 2.48409 6.0473 2.67481C6.0473 2.86553 5.88914 3.02369 5.69842 3.02369Z"
      fill="currentColor"
    />
    <path
      d="M3.14008 6.74501H2.20972C2.019 6.74501 1.86084 6.58685 1.86084 6.39612C1.86084 6.2054 2.019 6.04724 2.20972 6.04724H3.14008C3.3308 6.04724 3.48896 6.2054 3.48896 6.39612C3.48896 6.58685 3.3308 6.74501 3.14008 6.74501Z"
      fill="currentColor"
    />
    <path
      d="M6.16345 6.74501H4.30274C4.11202 6.74501 3.95386 6.58685 3.95386 6.39612C3.95386 6.2054 4.11202 6.04724 4.30274 6.04724H6.16345C6.35417 6.04724 6.51233 6.2054 6.51233 6.39612C6.51233 6.58685 6.35417 6.74501 6.16345 6.74501Z"
      fill="currentColor"
    />
    <path
      d="M7.58703 8.60577H2.41427C0.562864 8.60577 0 8.04756 0 6.21476V2.39101C0 0.558212 0.562864 0 2.41427 0H5.69842C5.88914 0 6.0473 0.15816 6.0473 0.348883C6.0473 0.539605 5.88914 0.697765 5.69842 0.697765H2.41427C0.953613 0.697765 0.697765 0.948961 0.697765 2.39101V6.21011C0.697765 7.65216 0.953613 7.90336 2.41427 7.90336H7.58238C9.04304 7.90336 9.29889 7.65216 9.29889 6.21011V3.84701C9.29889 3.65629 9.45705 3.49813 9.64777 3.49813C9.83849 3.49813 9.99665 3.65629 9.99665 3.84701V6.21011C10.0013 8.04756 9.43844 8.60577 7.58703 8.60577Z"
      fill="currentColor"
    />
    <path
      d="M7.79158 2.55841C7.7032 2.55841 7.61481 2.52585 7.54503 2.45607L6.84727 1.7583C6.71237 1.6234 6.71237 1.40012 6.84727 1.26522C6.98217 1.13032 7.20546 1.13032 7.34036 1.26522L7.79158 1.71644L9.40574 0.102275C9.54064 -0.0326267 9.76393 -0.0326267 9.89883 0.102275C10.0337 0.237176 10.0337 0.460461 9.89883 0.595362L8.03812 2.45607C7.96835 2.52585 7.87996 2.55841 7.79158 2.55841Z"
      fill="currentColor"
    />
  </svg>
);
export default PaySecurelyIcon;
